<div class="w-full h-screen bg-group-invite bg-cover place-content-center">

    <app-open-banner class="fixed top-0 left-0 w-full z-50" [path]="appDeepLinkPath"></app-open-banner>

    <div class="hidden md:block flex-row lg:w-2/3 h-1/2 justify-center place-content-center mx-16 lg:mx-auto">

        <div class="flex flex-row w-full justify-center content-center">

            <div class="w-full">
                <div class="mb-8">
                    <a href="https://atchurch.app"><img class="h-14"
                            src="assets/brand/atc_full_whiteOnTransparent.png" />
                    </a>
                </div>
                <p class="text-md capitalize text-white mb-2">
                    You've been Invited to Join
                </p>
                <p class="text-2xl font-semibold capitalize text-white mb-2">
                    {{group?.name}}
                </p>
                <p class="text-md font-light text-white mb-4">
                    on the AtChurch App
                </p>
                @if(isLoggedIn) {
                <app-btn-call-to-action [btnText]="'Join ' + (group?.name ?? '')" [isLoading$]="isLoading$"
                    (click)="onJoinGroup()"></app-btn-call-to-action>
                } @else {
                <app-btn-call-to-action btnText="Register and Join" [isLoading$]="isLoading$"
                    (click)="onRegister()"></app-btn-call-to-action>
                }
            </div>

            <div class="w-full">
                @if (group?.imageUrl) {
                <div class="rounded mb-4 mx-2">
                    <img alt="..." [src]="group?.imageUrl"
                        class="bg-gray-100 shadow-xl rounded w-full object-cover mx-auto align-middle border-none max-h-[250px]" />
                </div>
                } @else {
                <div
                    class="bg-gray-100 mb-4 uppercase text-primary-500 text-4xl flex justify-center items-center text-center h-64 w-128 rounded">
                    {{ group?.name | initials }}
                </div>
                }
                <p class="text-2xl text-center font-semibold capitalize text-white mb-4">
                    {{group?.name}}
                </p>
                <p class="text-md text-center font-light text-white mb-4">
                    {{group?.description}}
                </p>
                <p class="text-md text-center font-light text-white mb-4">
                    {{group?.address?.addressLine1}} {{group?.address?.addressLine1}}
                </p>
                <p class="text-md text-center font-light text-white mb-4">
                    {{group?.address?.city}} {{group?.address?.country}}
                </p>
            </div>
        </div>
    </div>

    <div class="block md:hidden flex-col justify-center place-items-center w-full mx-auto px-4 py-8">

        <div class="w-full mb-6">
            <a href="https://atchurch.app"><img class="h-10 mx-auto"
                    src="assets/brand/atc_full_whiteOnTransparent.png" />
            </a>
        </div>

        <p class="text-md text-center font-light text-white mb-1">
            You have been Invited to Join
        </p>
        <p class="text-2xl font-semibold text-center capitalize text-white mb-1">
            {{group?.name}}
        </p>
        <p class="text-md text-center font-light text-white mb-4">
            on the AtChurch App
        </p>
        @if (group?.imageUrl) {
        <div class="rounded mb-4 mx-2 shadow-lg">
            <img alt="..." [src]="group?.imageUrl"
                class="shadow-xl rounded w-full object-cover mx-auto align-middle border-none max-h-[250px]" />
        </div>
        }
        <div class="text-center mb-4">
            @if(isLoggedIn) {
            <button type="button"
                class="rounded-full text-md px-4 py-2 bg-gray-100 text-primary shadow hover:bg-secondary-500 hover:text-white hover:shadow-lg"
                (click)="onJoinGroup()">
                <i class="fa fa-circle-arrow-right mr-2"></i>
                Join {{ group?.name}}</button>
            } @else {
            <button type="button"
                class="rounded-full text-md px-4 py-2 bg-gray-100 text-primary shadow hover:bg-secondary-500 hover:text-white hover:shadow-lg"
                (click)="onRegister()">
                <i class="fa fa-circle-arrow-right mr-2"></i>Register and Join</button>
            }
        </div>
        <p class="text-md text-center font-light text-white mb-4">
            {{group?.description}}
        </p>
        <p class="text-md text-center font-light text-white mb-2">
            {{group?.address?.addressLine1}} {{group?.address?.addressLine1}}
        </p>
        <p class="text-md text-center font-light text-white mb-4">
            {{group?.address?.city}} {{group?.address?.country}}
        </p>

    </div>

    <div class="absolute bottom-1 w-full center">
        <p class="text-xs text-gray-400 text-center px-4 py-1">
            Background Photo by <a
                href="https://unsplash.com/@kirp?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Andrew
                Kliatskyi</a> on <a
                href="https://unsplash.com/photos/background-pattern-r4HT6aurLQw?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>

        </p>
    </div>
    <!-- </div> -->
</div>
<!--  <div class="flex justify-between items-center w-full mb-4">


        <div class="rounded-t bg-white p-4">
            <div class="text-center flex justify-between items-center">
                <h6 class="text-primary-500 text-lg pl-2 font-bold uppercase">
                    {{group?.name}}
                </h6>
                <div class="flex flex-row gap-4 justify-center items-center">
                    <span class="text-sm hidden md:block text-blueGray-400">Membership:</span>
                    <app-btn-member-status [status]="group?.memberStatus" [isDisabled]="true"></app-btn-member-status>
                </div>
            </div>
        </div>

       <div class="flex flex-col p-6 shadow-lg rounded-b bg-blueGray-100 border-0">

            <div class="flex flex-col-reverse lg:flex-row">
                <div *ngIf="group" class="flex flex-wrap w-full lg:w-4/6 lg:mr-6">

                    <div class="w-full lg:w-12/12">
                        <div class="relative w-full mb-3">

                            <div class="w-full lg:w-12/12 mb-8">
                                <div class="relative w-full mb-3">
                                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                        Description
                                    </label>
                                    <span class="text-blueGray-600 text-sm">{{group.description}}</span>
                                </div>
                            </div>
                            <div class="w-full lg:w-12/12 mb-8">
                                <div class="w-full">
                                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                        Address
                                    </label>
                                    <span
                                        class="text-blueGray-600 normal-case text-sm">{{group.address.addressLine1}}</span>
                                    <span class="text-blueGray-600 normal-case text-sm">
                                        {{group.address.addressLine2}}</span>
                                    <span class="text-blueGray-600 normal-case text-sm"> {{group.address?.city}}</span>
                                    <span class="text-blueGray-600 normal-case text-sm">
                                        {{group.address.country}}</span>
                                </div>
                            </div>
                            <div *ngIf="group.primaryContact?.contact" class="w-full lg:w-12/12 mb-8">
                                <div class="w-full">
                                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                        Primary Contact
                                    </label>
                                    <span
                                        class="text-blueGray-600 capitalize text-sm">+{{group.primaryContact?.phoneCode}}</span>
                                    <span class="text-blueGray-600 text-sm">
                                        {{group.primaryContact?.contact}}</span>
                                </div>
                            </div>
                            <div *ngIf="group.secondaryContact?.contact" class="w-full lg:w-12/12 mb-8">
                                <div class="w-full">
                                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                        Secondary Contact
                                    </label>
                                    <span
                                        class="text-blueGray-600 capitalize text-sm">+{{group.secondaryContact?.phoneCode}}</span>
                                    <span class="text-blueGray-600 text-sm">
                                        {{group.secondaryContact?.contact}}</span>
                                </div>
                            </div>
                            <div class="w-full lg:w-12/12 mb-8">
                                <div class="w-full">
                                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                        Email
                                    </label>
                                    <span class="text-blueGray-600 text-sm">{{group.email}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
    </div> -->